export const COMMENT_TYPES = {
	REVIEW: "REVIEW",
	VALIDATION: "VALIDATION",
};
